export enum DocType {
  RECEIPT = 'RECEIPT',
  INVOICE = 'INVOICE',
  CREDIT_NOTE = 'CREDIT_NOTE',
  PURCHASE_ORDER = 'PURCHASE_ORDER',
  CUSTOMER_ORDER = 'CUSTOMER_ORDER',
  DEBIT_NOTE = 'DEBIT_NOTE',
  QUOTATION = 'QUOTATION'
}
